export default "__VITE_ASSET__D8T$AcnU__"